"use client";
import * as React from "react";
const SvgManualGearOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 15", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 .9C0 .4.41 0 .91 0a.9.9 0 0 1 .92.9v4.54H6.4V.9c0-.5.41-.91.91-.91a.9.9 0 0 1 .92.9v4.54h4.57V.9c0-.5.41-.91.91-.91a.9.9 0 0 1 .92.9v6.35h-6.4v4.53c0 .5-.41.9-.92.9a.9.9 0 0 1-.91-.9V7.25H1.83v4.53c0 .5-.41.9-.92.9a.9.9 0 0 1-.91-.9zm15.18 11.7c.45-.27.82-.73.82-1.27v-.9a1.4 1.4 0 0 0-1.37-1.37h-3.2v5.44h1.37v-1.81h1l.83 1.81H16zm-.55-2.18v.9H12.8v-.9z", clipRule: "evenodd" }));
export {
  SvgManualGearOutlined as default
};
